module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 92.9527ec33.png";